import React from "react";
import {
    Container,
    Form,
    Col,
    FormGroup,
    Input,
    Row,
    Button,
    Card,
    CardText,
    CardBody,
    CardSubtitle,
    CardTitle,
    Spinner,
} from "reactstrap";
import "mapbox-gl/dist/mapbox-gl.css";

import CountrySelect from "react-bootstrap-country-select";
import {
    Map,
    Marker,
    GoogleApiWrapper,
    geocodeByLatLng,
    InfoWindow,
} from "google-maps-react";
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
} from "react-places-autocomplete";
import Geocode from "react-geocode";

import { useState } from "react";
import truck from "../../assets/img/Truck.png";
import { mapCards } from "../../helpers/mapCards";
import { useEffect } from "react";
import { useSelector } from "react-redux";
Geocode.setApiKey("AIzaSyDJ05MSObzmYtm4ql0L0bbzibVFmi6BruE");
function MapSection(props) {
    const { distributers, get_loading } = useSelector(
        (state) => state.distributer
    );
    const [address, setAddress] = useState("");
    const [initCenter, setInitCenter] = useState({
        lat: 33.73144,
        lng: 73.045841,
    });
    const [mapCenter, setMapCenter] = useState({
        lat: 33.73144,
        lng: 73.045841,
    });
    const [mile, setMile] = useState("10");
    const [selectedCategory, setSelectedCategory] = useState("all");
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [activeMarker, setActiveMarker] = useState(null);
    const [selectedDistributer, setSelectedDistributer] = useState(null);

    const handlemapChange = (newAddress) => {
        setAddress(newAddress);
    };
    const getLatLngAddress = (lat, lng) => {
        Geocode.fromLatLng(lat, lng).then(
            (response) => {
                let address;
                address = response.results[0].formatted_address;
                setAddress(address);
            },
            (error) => {
                console.error(error);
            }
        );
    };
    const handleSelect = (newAddress) => {
        setAddress(newAddress);
        geocodeByAddress(newAddress)
            .then((results) => getLatLng(results[0]))
            .then((latLng) => {
                // console.log("Success", latLng);

                // update center state
                setInitCenter(latLng);
                setMapCenter(latLng);
            })
            .catch((error) => console.error("Error", error));
    };
    const handleMarkerDrag = (e) => {
        // console.log("handle run...", e);
        const latLng = { lat: e.latLng.lat(), lng: e.latLng.lng() };
        setMapCenter(latLng);
        setInitCenter(latLng);
        getLatLngAddress(latLng.lat, latLng.lng);
    };
    const rad = (x) => {
        return (x * Math.PI) / 180;
    };
    const withRadius = (storePos, cusPos, kms, name) => {
        const R = 6371; // Earth's radius (mean radius = 6,371km)
        const dLat = rad(cusPos.lat - storePos.lat);
        const dLong = rad(cusPos.lng - storePos.lng);
        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(rad(storePos.lat)) *
                Math.cos(rad(cusPos.lat)) *
                Math.sin(dLong / 2) *
                Math.sin(dLong / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        // Multiplying by 0.621371 to calculate distance in miles
        const d = R * c * 0.621371;
        // console.log("here 2", kms, d, name);
        return d <= kms;
    };
    const handleTabClick = (category) => {
        let newSelectedCategories = [...selectedCategories];
        if (selectedCategories.includes(category)) {
            newSelectedCategories = selectedCategories.filter(
                (c) => c !== category
            );
        } else {
            newSelectedCategories.push(category);
        }
        setSelectedCategories(newSelectedCategories);
    };
    const getFilteredDistributers = () => {
        if (address == "" && selectedCategories.length == 0) {
            return distributers;
        } else if (selectedCategories?.length != 0 && address == "") {
            let filteredDistr = distributers?.filter((distributer) => {
                return selectedCategories.includes(distributer.category);
            });
            return filteredDistr;
        } else if (address && selectedCategories?.length == 0) {
            let filteredDistr = distributers?.filter((distributer) => {
                return withRadius(
                    distributer.coardinates,
                    mapCenter,
                    mile,
                    distributer.name
                );
            });
            return filteredDistr;
        } else if (address && selectedCategories?.length > 0) {
            let filteredDistr = distributers?.filter((distributer) => {
                return (
                    (selectedCategories.length === 0 ||
                        selectedCategories.includes(distributer.category)) &&
                    withRadius(
                        distributer.coardinates,
                        mapCenter,
                        mile,
                        distributer.name
                    )
                );
            });
            return filteredDistr;
        }
    };

    const handleMileChange = (e) => {
        setMile(e.target.value);
    };
    useEffect(() => {
        navigator.geolocation.getCurrentPosition((pos) => {
            getLatLngAddress(pos.coords.latitude, pos.coords.longitude);
            setMapCenter({
                lat: pos.coords.latitude,
                lng: pos.coords.longitude,
            });
            setInitCenter({
                lat: pos.coords.latitude,
                lng: pos.coords.longitude,
            });
        });
    }, []);
    return (
        <Container className="mapSection p-5 mt-5">
            <Row>
                <Col className="d-lg-flex align-items-center" md={6}>
                    <PlacesAutocomplete
                        value={address}
                        onChange={handlemapChange}
                        onSelect={handleSelect}
                    >
                        {({
                            getInputProps,
                            suggestions,
                            getSuggestionItemProps,
                            loading,
                        }) => (
                            <div>
                                <input
                                    {...getInputProps({
                                        placeholder: "Business Position ...",
                                        className: "location-main-input",
                                    })}
                                    style={{
                                        border: "1px solid ",
                                        padding: "10px",
                                        marginBottom: "10px",
                                        height: "35px",
                                        marginRight: "10px",
                                    }}
                                />
                                <div className="autocomplete-dropdown-container">
                                    {loading && <div>Loading...</div>}
                                    {suggestions.map((suggestion) => {
                                        const className = suggestion.active
                                            ? "suggestion-item--active"
                                            : "suggestion-item";
                                        // inline style for demonstration purpose
                                        const style = suggestion.active
                                            ? {
                                                  backgroundColor: "#fafafa",
                                                  cursor: "pointer",
                                              }
                                            : {
                                                  backgroundColor: "#ffffff",
                                                  cursor: "pointer",
                                              };
                                        return (
                                            <div
                                                className="input-suggestion"
                                                {...getSuggestionItemProps(
                                                    suggestion,
                                                    {
                                                        style,
                                                    }
                                                )}
                                            >
                                                <span>
                                                    {suggestion.description}
                                                </span>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        )}
                    </PlacesAutocomplete>

                    <FormGroup className=" mapSection__select w-50">
                        <Input
                            id="exampleSelect"
                            name="select"
                            type="select"
                            value={mile}
                            onChange={(e) => {
                                handleMileChange(e);
                            }}
                        >
                            <option value="10">10 mi</option>
                            <option value="20">20 mi</option>
                            <option value="50">50 mi</option>
                            <option value="100">100 mi</option>
                            <option value="200">200 mi</option>
                        </Input>
                    </FormGroup>
                </Col>
            </Row>
            {/* <Row>
                <Col lg="6" md={6} sm={12} xs={12}>
                    <FormGroup className=" mapSection__select">
                        <Input
                            id="exampleSelect"
                            name="select"
                            type="select"
                            onChange={(e) => {
                                handleMileChange(e);
                            }}
                        >
                            <option disabled selected value="">
                                Toggle Your Favourite Brands
                            </option>
                            <option value="10">10 mi</option>
                            <option value="20">20 mi</option>
                            <option value="50">50 mi</option>
                            <option value="100">100 mi</option>
                            <option value="200">200 mi</option>
                        </Input>
                    </FormGroup>
                </Col>
            </Row> */}
            <Row>
                <div className="ml-3 mb-2"><b>Search By Services</b></div>
                <Col
                    md={12}
                    className="d-flex align-items-center overflow-auto"
                >
                    <div
                        onClick={() => handleTabClick("brick_&_mortar_stores")}
                        className={` 
                          mapSection__link  ${
                              selectedCategories.includes(
                                  "brick_&_mortar_stores"
                              )
                                  ? "bg-primary text-white"
                                  : ""
                          }  text-nowrap p-2 d-flex align-items-center  mr-2 `}
                    >
                        <i className="fa-solid fa-circle mr-1"></i>
                        Brick & Mortar Stores
                    </div>
                    <div
                        className={` d mapSection__link ${
                            selectedCategories.includes("delivery_services")
                                ? "bg-primary text-white"
                                : ""
                        }  text-nowrap p-2  d-flex align-items-center  mr-2 
                        `}
                        onClick={() => handleTabClick("delivery_services")}
                    >
                        <i className="fa-solid fa-circle mr-1"></i>
                        Delivery Service
                    </div>
                    <div
                        className={`mapSection__link  ${
                            selectedCategories.includes("online_stores")
                                ? "bg-primary text-white"
                                : ""
                        } text-nowrap  p-2  d-flex align-items-center mr-2`}
                        onClick={() => handleTabClick("online_stores")}
                    >
                        <i className="fa-solid fa-circle mr-1"></i>
                        Online Stores
                    </div>
                    <div
                        className={`mapSection__link  ${
                            selectedCategories.includes("ida_members")
                                ? "bg-primary text-white"
                                : ""
                        }  text-nowrap  p-2  d-flex align-items-center mr-2`}
                        onClick={() => handleTabClick("ida_members")}
                    >
                        <i className="fa-solid fa-circle mr-1"></i>
                        IDA Supplier Members
                    </div>
                </Col>
            </Row>
                <div className="mt-3 mb-0"><b>Search By Brands</b></div>
            <Row className="mt-5 addressRow">
                <Col md={4} className="addressRow__cards  ">
                    {get_loading ? (
                        <div className="text-center mt-2">
                            <Spinner />
                        </div>
                    ) : getFilteredDistributers()?.length == 0 ? (
                        <div className="mt-2">
                            <strong>No Business Found</strong>
                        </div>
                    ) : (
                        getFilteredDistributers()?.map((item, index) => {
                            return (
                                <Card
                                    className="mb-2"
                                    key={index}
                                    style={{ cursor: "pointer" }}
                                >
                                    <CardBody
                                        onClick={() => {
                                            setSelectedDistributer(item);
                                            setInitCenter({
                                                lat: item?.coardinates?.lat,
                                                lng: item?.coardinates?.lng,
                                            });
                                        }}
                                    >
                                        <div className="d-flex justify-content-between">
                                            <img
                                                src={truck}
                                                width="100px"
                                                height="100px"
                                                alt=""
                                            />
                                        </div>

                                        <CardTitle tag="h5">
                                            {item?.name +
                                                " (" +
                                                item?.company +
                                                ")"}
                                        </CardTitle>
                                        <CardText>{item?.address}</CardText>
                                    </CardBody>
                                </Card>
                            );
                        })
                    )}
                </Col>
                <Col lg={8} md={8} sm={12} xs={12}>
                    <Map
                        className="mainMap"
                        google={props.google}
                        zoom={12}
                        initialCenter={initCenter}
                        center={mapCenter}
                    >
                        {selectedDistributer && (
                            <InfoWindow
                                position={selectedDistributer.coardinates}
                                visible={true}
                                marker={activeMarker}
                                onCloseClick={() => {
                                    setSelectedDistributer(null);
                                }}
                            >
                                <div>
                                    <h5>{selectedDistributer?.name}</h5>
                                    <span>{selectedDistributer?.company}</span>
                                </div>
                            </InfoWindow>
                        )}
                        {getFilteredDistributers()?.map((distributer) => (
                            <Marker
                                key={distributer.id}
                                position={distributer.coardinates}
                                onClick={() => {
                                    setSelectedDistributer(distributer);
                                }}
                            />
                        ))}

                        <Marker
                            key={"marker"}
                            position={mapCenter}
                            draggable={true}
                            onDragend={(t, map, coord) => {
                                handleMarkerDrag(coord);
                            }}
                        />
                    </Map>
                </Col>
            </Row>
        </Container>
    );
}
export default GoogleApiWrapper({
    apiKey: "AIzaSyDJ05MSObzmYtm4ql0L0bbzibVFmi6BruE",
})(MapSection);
